import React, { useEffect, useState} from 'react';
import Card from '../shared/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownWideShort, faListCheck, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import PostForm from '../shared/PostForm';
import Modal from '../ui/Modal';
import useModal from '../../hooks/useModal'
import ReactPaginate from 'react-paginate';
import { useFetchCategory } from '../../hooks/useFetchData';

const List = ({ items, title, subtitle, formConfig1, formConfig2, type, showButtons, }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState();
  const [currentPageMap, setCurrentPageMap] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const { data: categories, loading, error } = useFetchCategory();
  const [selectedNames, setSelectedNames] = useState([]);
  const itemsPerPage = 12;
  const [initialValues, setInitialValues] = useState(null);
  const handlePageClick = (event) => {
    setCurrentPageMap(event.selected);
    window.scrollTo(0, 0);
  };

  const startOffset = Math.min(currentPageMap * itemsPerPage, items.length);
  const endOffset = Math.min(startOffset + itemsPerPage, items.length);
  const currentItems = items.slice(startOffset, endOffset);
  const pageCount = Math.max(1, Math.ceil(items.length / itemsPerPage));
  const hasSelectedNames = selectedNames && selectedNames.length > 0;
  const token = localStorage.getItem('token');
  // Object.keys(categories).forEach((key) => {
  //   categories[key].map((item) => {
  //     console.log(`Key: ${key}, ID: ${item.id}, Name: ${item.name}`);
  //   });
  // });

  useEffect(() => {
    if (searchParams && searchParams.toString) {
      const queryParams = searchParams.toString().split('&').reduce((acc, param) => {
        const [key, value] = param.split('=');
        acc[key] = value ? value.split(',') : [];
        return acc;
      }, {});
  
      const selectedNamesArr = [];
  
      Object.keys(queryParams).forEach((key) => {
        if (categories[key]) {
          queryParams[key].forEach((value) => {
            // value が配列でなくても対応できるように変換
            const matched = categories[key].find((item) => item.id.toString() === value);
            if (matched) {
              selectedNamesArr.push(matched.name); // 一致するnameを追加
            }
          });
        }
      });
  
      setSelectedNames(selectedNamesArr); // 状態を更新
    }
  }, [searchParams, categories]);

  if (!Array.isArray(items) || items.length === 0) {
    return <p>現在表示可能なアイテムはありません。</p>;
  }

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  const handlePost = async () => {
    if(token){
      {type === 'sharehouse' ?(
        window.location.href = "/sharehouse_post"
      ): type === 'transaction' ?(
        window.location.href = "/transaction_post"
      ):(
        window.location.href = "/job_post"
      )}
    }else{
      setCurrentPage("404-login");
      openModal();
    }
  }

  console.log('startOffset:', startOffset);
  console.log('currentItems:', currentItems);

  const formConfig = currentPage === "terms" ? formConfig1 : formConfig2;

  return (
    <>
    <div className="postlist">
      <h1 className='postlist__ttl'>{title || 'Shared House'}</h1>
      <h4 className='postlist__ttl-kana'>{subtitle || 'シェアハウス掲示板'}</h4>
      <div className='buttons sharehouse'>
        <button class="button btn-white" onClick={() => {openModal(); setCurrentPage("terms");}}>
          <span>条件で検索<FontAwesomeIcon icon={faListCheck} style={{color: "#015b02",}} /></span>
        </button>
        <button class="button btn-white" onClick={() => {openModal(); setCurrentPage("sorting");}}>
          <span>並べ替え<FontAwesomeIcon icon={faArrowDownWideShort} style={{color: "#015b02",}} /></span>
        </button>
        {showButtons && (
        <button class="button btn-white">
          <a href='/sharehouse/map'>
            <span>MAP検索<FontAwesomeIcon icon={faLocationDot} /></span>
          </a>
        </button>
        )}
      </div>
      { hasSelectedNames &&
      <div className='postlist__term'>
        検索条件：　
        {selectedNames.map((selectedName, index) => (
          <span key={index}>{selectedName}　</span>
        ))}
      </div>
      }
      <div className='cards'>
        {currentItems.map((item) => (
          <Card key={item.id} item={item} type={type} />
        ))}
      </div>
      <ReactPaginate
        breakLabel="..."
        nextLabel="次 >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< 前"
        containerClassName="pagination"
        activeClassName="active"
      />
    </div>
    <Modal isOpen={isOpen} closeModal={closeModal} currentPage={currentPage}  setCurrentPage={setCurrentPage} className="login">
      {currentPage === "terms" ? (
        <>
        <h2 className='login__ttl'>条件検索</h2>
        <div className='terms__form'>
          <PostForm
          title = {'条件検索'}
          formConfig={formConfig}
          type={'terms'}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          closeModal={closeModal}
          initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
            acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
            return acc;
          }, {})}
          />
        </div>
        </>
      ) : currentPage === "sorting" ?(
        <>
        <h2 className='login__ttl'>条件検索</h2>
        <div className='terms__form'>
          <PostForm
          title = {'並べ替え検索'}
          formConfig={formConfig}
          type={type}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchParams={setSearchParams}
          // hundleSearch={hundleSearch}
          closeModal={closeModal}
          initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
            acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
            return acc;
          }, {})}
          />
        </div>
        </>
      ):null}
    </Modal>
    <div className='button post-list' onClick={handlePost}>
      <span>POST</span>
    </div>
    </>
  );
};

export default List;